import { reads } from '@ember/object/computed';
import { computed } from '@ember/object';
import DeviceProfileSettings from '@square/dashboard-data/models/device-profile-settings';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';

// Remote device settings and associated metadata
export default ProtoBaseModel.extend({
  token: attr(String),
  version: attr(Number),
  settings: attr(DeviceProfileSettings),
  name: attr(String),
  shared: attr(Boolean),
  type: reads('settings.type'),
  isDirty: computed('_dirtyAttributes.[]', 'settings.isDirty', function (...args) {
    return this._super(...args) || this.settings?.isDirty;
  })
}).reopenClass({
  primaryKey: 'token',
  createDefault(options) {
    const settingsOptions = {};
    if (options && options.type) {
      settingsOptions.type = options.type;
    }
    const deviceProfileOptions = Object.assign({
      settings: DeviceProfileSettings.create(settingsOptions)
    }, options);
    return this.create(deviceProfileOptions);
  }
});